import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

const DEFAULT_COUNT = 2;
const MIN = 1;
const MAX = 30;

export default function DecisionOptionCountDialog({ open, onClose, onConfirm, title = "New Decision Section" }) {
  const [raw, setRaw] = useState(String(DEFAULT_COUNT));

  useEffect(() => {
    if (open) setRaw(String(DEFAULT_COUNT));
  }, [open]);

  const parsed = Math.floor(Number(raw));
  const count = Number.isFinite(parsed) ? Math.min(MAX, Math.max(MIN, parsed)) : DEFAULT_COUNT;
  const invalid = raw !== "" && !Number.isFinite(parsed);

  const handleConfirm = () => {
    if (invalid) return;
    onConfirm(count);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="How many options?"
          type="number"
          fullWidth
          inputProps={{ min: MIN, max: MAX }}
          value={raw}
          onChange={(e) => setRaw(e.target.value)}
          error={invalid}
          helperText={invalid ? `Enter a number from ${MIN} to ${MAX}` : `Between ${MIN} and ${MAX}`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleConfirm} variant="contained" disabled={invalid}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
